import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { toast } from 'react-hot-toast';
import { useParams, useNavigate } from 'react-router-dom';
import { Card, Col, Form, Row } from 'react-bootstrap';
import CardHeader from '../../components/common/CardHeader';
import LinkButton from '../../components/common/LinkButton';
import {
      FormButton,
      FormDescription,
      FormImage,
      FormInput,
      FormSelect,
      FormSeo,
      FormStatusSelect
} from '../../components/form';
import MultipleImage from '../../components/form/MultipleImage';

const DestinationEdit = () => {
      const { destinationId } = useParams();
      const navigate = useNavigate();
      const [categories, setCategories] = useState([]);
      const [loadingData, setLoadingData] = useState(false);

      const [title, setTitle] = useState('');
      const [slug, setSlug] = useState('');
      const [image, setImage] = useState('');
      const [category, setCategory] = useState('');
      const [imageUrl, setImageUrl] = useState('');
      const [images, setImages] = useState([]);
      const [imagesUrl, setImagesUrl] = useState([]);
      const [productImages, setProductImages] = useState([]);
      const [description, setDescription] = useState('');
      const [status, setStatus] = useState('');
      const [loading, setLoading] = useState(false);

      const [seoTitle, setSeoTitle] = useState(null);
      const [bannerImage, setBannerImage] = useState('');
      const [bannerImageUrl, setBannerImageUrl] = useState(null);
      const [seoKeyword, setSeoKeyword] = useState(null);
      const [seoDescription, setSeoDescription] = useState(null);

      const loadData = async () => {
            setLoadingData(true);
            await axios
                  .get(
                        `${process.env.REACT_APP_SECRET_KEY}/api/dashboard/destinations/${destinationId}`,
                        {
                              headers: {
                                    Authorization: `Bearer ${JSON.parse(
                                          localStorage.getItem('token')
                                    )}`,
                                    'Content-Type': 'multipart/form-data'
                              }
                        }
                  )
                  .then((response) => {
                        if (response.data.result === 'success') {
                              setSlug(response.data.destination.slug);
                              setTitle(response.data.destination.title);
                              setDescription(
                                    response.data.destination.description
                              );
                              setCategory(
                                    response.data.destination.category_id
                              );
                              setProductImages(
                                    response.data.destination.images
                              );
                              setStatus(response.data.destination.status);
                              setImageUrl(response.data.destination.image);
                              setBannerImageUrl(
                                    response.data.destination.banner_image
                              );
                              setSeoTitle(response.data.destination.seo_title);
                              setSeoKeyword(
                                    response.data.destination.seo_keyword
                              );
                              setSeoDescription(
                                    response.data.destination.seo_description
                              );
                        }
                  })
                  .catch((error) => {
                        console.log(error.message);
                  });

            await axios
                  .get(
                        `${process.env.REACT_APP_SECRET_KEY}/api/dashboard/destinations/categories/list`,
                        {
                              headers: {
                                    Authorization: `Bearer ${JSON.parse(
                                          localStorage.getItem('token')
                                    )}`,
                                    'Content-Type': 'multipart/form-data'
                              }
                        }
                  )
                  .then((response) => {
                        if (response.data.result === 'success') {
                              setCategories(response.data.categories);
                        }
                  })
                  .catch((error) => {
                        console.log(error.message);
                  });
            setLoadingData(false);
      };

      useEffect(() => {
            loadData();
      }, []);

      const handleFormSubmit = async (event) => {
            event.preventDefault();
            setLoading(true);
            const data = {
                  slug: slug,
                  title: title,
                  status: status,
                  category: category,
                  description: description,
                  image: image,
                  images: imagesUrl,
                  seo_title: seoTitle,
                  banner_image: bannerImage,
                  seo_keyword: seoKeyword,
                  seo_description: seoDescription
            };

            let updatedSlug = false;

            const handleUpdateSlug = () => {
                  if (updatedSlug) {
                        navigate(`/dashboard/destinations/${updatedSlug}/edit`);
                  }
            };

            await axios
                  .post(
                        `${process.env.REACT_APP_SECRET_KEY}/api/dashboard/destinations/${destinationId}`,
                        data,
                        {
                              headers: {
                                    Authorization: `Bearer ${JSON.parse(
                                          localStorage.getItem('token')
                                    )}`,
                                    'Content-Type': 'multipart/form-data'
                              }
                        }
                  )
                  .then((response) => {
                        if (response.data.result === 'success') {
                              toast.success(response.data.message);
                              updatedSlug = slug;
                              handleUpdateSlug();
                        }
                        if (response.data.result === 'error') {
                              if (response.data.message.title) {
                                    toast.error(response.data.message.title);
                              }
                              if (response.data.message.description) {
                                    toast.error(
                                          response.data.message.description
                                    );
                              }
                              if (response.data.message.status) {
                                    toast.error(response.data.message.status);
                              }
                              if (response.data.message.slug) {
                                    toast.error(response.data.message.slug);
                              }
                              if (response.data.message.seo_description) {
                                    toast.error(
                                          response.data.message.seo_description
                                    );
                              }
                              if (response.data.message.seo_title) {
                                    toast.error(
                                          response.data.message.seo_title
                                    );
                              }
                              if (response.data.message.banner_image) {
                                    toast.error(
                                          response.data.message.banner_image
                                    );
                              }
                              if (response.data.message.seo_keyword) {
                                    toast.error(
                                          response.data.message.seo_keyword
                                    );
                              }
                        }
                  })
                  .catch((error) => {
                        toast.error(error.message);
                  });
            setLoading(false);
      };

      return (
            <>
                  <Form onSubmit={handleFormSubmit}>
                        <Row>
                              <Col>
                                    <Card>
                                          <CardHeader title="Create Destination">
                                                <LinkButton
                                                      title="Back"
                                                      link="/dashboard/destinations"
                                                />
                                          </CardHeader>
                                          <Card.Body>
                                                <Row className="g-3">
                                                      <FormInput
                                                            title="Title"
                                                            classes={8}
                                                            required={true}
                                                            handleChange={
                                                                  setTitle
                                                            }
                                                            value={title}
                                                      />
                                                      <FormInput
                                                            title="Slug"
                                                            classes={4}
                                                            required={true}
                                                            value={slug}
                                                            handleChange={
                                                                  setSlug
                                                            }
                                                      />

                                                      <FormSelect
                                                            options={categories}
                                                            loading={
                                                                  loadingData
                                                            }
                                                            selected={category}
                                                            classes={4}
                                                            title="Category"
                                                            setData={
                                                                  setCategory
                                                            }
                                                      />
                                                      <FormStatusSelect
                                                            title="Status"
                                                            classes={4}
                                                            selected={status}
                                                            setStatus={
                                                                  setStatus
                                                            }
                                                      />
                                                      <FormDescription
                                                            title="Description"
                                                            description={
                                                                  description
                                                            }
                                                            setDescription={
                                                                  setDescription
                                                            }
                                                      />
                                                </Row>
                                          </Card.Body>
                                    </Card>

                                    <Card className="mt-4">
                                          <Card.Body>
                                                <Row>
                                                      <FormImage
                                                            title="Featured Image"
                                                            setImage={setImage}
                                                            setImageUrl={
                                                                  setImageUrl
                                                            }
                                                            imageUrl={imageUrl}
                                                      />
                                                      <FormImage
                                                            title="Banner Image"
                                                            setImage={
                                                                  setBannerImage
                                                            }
                                                            setImageUrl={
                                                                  setBannerImageUrl
                                                            }
                                                            imageUrl={
                                                                  bannerImageUrl
                                                            }
                                                      />
                                                      <MultipleImage
                                                            title="Multiple Images"
                                                            grid={4}
                                                            classes={12}
                                                            images={images}
                                                            websiteImages={
                                                                  productImages
                                                            }
                                                            type="destinations"
                                                            setProductImages={
                                                                  setProductImages
                                                            }
                                                            setImages={
                                                                  setImages
                                                            }
                                                            slug={destinationId}
                                                            setImageFiles={
                                                                  setImagesUrl
                                                            }
                                                      />
                                                </Row>
                                          </Card.Body>
                                    </Card>

                                    <FormSeo
                                          setSeoDescription={setSeoDescription}
                                          setSeoTitle={setSeoTitle}
                                          setSeoKeyword={setSeoKeyword}
                                          title={seoTitle}
                                          keyword={seoKeyword}
                                          description={seoDescription}
                                    />

                                    <Card className="mt-4 mb-5">
                                          <Card.Body>
                                                <Col lg={12}>
                                                      <FormButton
                                                            title="Submit"
                                                            loading={loading}
                                                      />
                                                </Col>
                                          </Card.Body>
                                    </Card>
                              </Col>
                        </Row>
                  </Form>
            </>
      );
};

export default DestinationEdit;
